import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, LifeBuoy } from "lucide-react";
import { NAV } from "../data/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-40 w-full bg-[var(--tb-bg)]/95 backdrop-blur-md border-b transition-shadow ${
        scrolled ? "shadow-sm border-[var(--tb-border)]" : "border-transparent"
      }`}
    >
      <nav aria-label="Primary" className="container-page flex items-center justify-between py-4">
        <Link
          to="/"
          data-testid="nav-logo-link"
          className="flex items-center gap-2.5 group"
          onClick={() => setOpen(false)}
        >
          <span
            aria-hidden="true"
            className="grid place-items-center h-9 w-9 rounded-full bg-[var(--tb-primary)] text-white font-serif-display text-lg shadow-sm group-hover:bg-[var(--tb-primary-hover)] transition-colors"
          >
            T
          </span>
          <span className="font-serif-display text-lg md:text-xl text-[var(--tb-text)] leading-tight">
            Thrive Bridge
          </span>
        </Link>

        <ul className="hidden lg:flex items-center gap-1">
          {NAV.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-full text-sm font-medium transition-colors ${
                    isActive
                      ? "text-[var(--tb-primary)] bg-[var(--tb-surface)]"
                      : "text-[var(--tb-text-2)] hover:text-[var(--tb-primary)] hover:bg-[var(--tb-surface)]/60"
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/get-support"
            data-testid="nav-get-support-cta"
            className="inline-flex items-center gap-2 rounded-full bg-[var(--tb-primary)] hover:bg-[var(--tb-primary-hover)] text-white px-5 py-2.5 text-sm font-semibold shadow-sm hover:shadow-md transition-all hover:-translate-y-0.5"
          >
            <LifeBuoy className="h-4 w-4" aria-hidden="true" /> Get Support
          </Link>
        </div>

        <button
          type="button"
          data-testid="nav-mobile-toggle"
          className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-full border border-[var(--tb-border)] text-[var(--tb-text)]"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-[var(--tb-border)] bg-[var(--tb-bg)]">
          <ul className="container-page py-3 flex flex-col gap-1">
            {NAV.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === "/"}
                  data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                  className={({ isActive }) =>
                    `block px-4 py-3 rounded-xl font-medium ${
                      isActive
                        ? "bg-[var(--tb-surface)] text-[var(--tb-primary)]"
                        : "text-[var(--tb-text-2)] hover:bg-[var(--tb-surface)]/70"
                    }`
                  }
                  onClick={() => setOpen(false)}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
            <li className="pt-2">
              <Link
                to="/get-support"
                data-testid="mobile-nav-get-support-cta"
                onClick={() => setOpen(false)}
                className="block text-center w-full rounded-full bg-[var(--tb-primary)] hover:bg-[var(--tb-primary-hover)] text-white px-5 py-3 font-semibold"
              >
                Get Support
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
